<template>
    <div class="head">
        <div class="logo">JSYDATA数据服务平台</div>
        <span class="version">{{ version }}</span>
        <div class="menus">
            <div :class="current==='#/datasource'?'menu iconfont icon-database menu-show':'menu iconfont icon-database'" @click="clickMenu('/datasource')">
                数据库
            </div>
            <div :class="current==='#/api'?'menu iconfont icon-api menu-show':'menu iconfont icon-api'" @click="clickMenu('/api')">
                接口
            </div>
            <div :class="current==='#/group'?'menu iconfont icon-table menu-show':'menu iconfont icon-table'" @click="clickMenu('/group')">
                接口分组
            </div>
            <div :class="current==='#/agent'?'menu iconfont icon-http menu-show':'menu iconfont icon-http'" @click="clickMenu('/agent')">
                接口代理
            </div>
            <div :class="current==='#/token'?'menu iconfont icon-quanxian menu-show':'menu iconfont icon-quanxian'" @click="clickMenu('/token')">
                令牌
            </div>
            <div :class="current==='#/system'?'menu iconfont icon-ziyuan menu-show':'menu iconfont icon-ziyuan'" @click="clickMenu('/system')">
                系统变量
            </div>
            <div :class="current==='#/setting/password'?'menu iconfont icon-shezhi menu-show':'menu iconfont icon-shezhi'" @click="clickMenu('/setting/password')">
                修改密码
                <!--<div class="submenus">-->
                    <!--<div class="submenu" @click="clickMenu('/setting/password',4)">修改密码</div>-->
                    <!--&lt;!&ndash;<div class="submenu" @click="clickMenu('/setting/firewall')">防火墙</div>&ndash;&gt;-->
                <!--</div>-->
            </div>

        </div>
        <div class="right">
            <span class="close" @click="onLogout">
              <i class="icon-close"></i>
              <!--<span class="desc">退出登录</span>-->
            </span>
            <!--<div class="mode">{{ this.$store.state.mode }}</div>-->
            <!--<span>{{ languageName }}</span>-->
            <!--<span class="lang el-icon-arrow-down">-->
            <!--</span>-->
            <!--<div class="options">-->
                <!--<div class="option" v-for="item in langs" @click="changeLanguage(item)">{{ item.name }}</div>-->
            <!--</div>-->
        </div>
    </div>
</template>

<script>
    export default {
        name: "homeHeader",
        data() {
            return {
                langs: [{name: 'english', value: 'en'}, {name: '中文', value: 'cn'}],
                currentLang: this.$i18n.locale,
                version: null,
                current:""
            }
        },
        methods: {
            clickMenu(data) {
                this.current = "#"+data;
                this.$router.push(data)
            },
            changeLanguage(data) {
                this.$i18n.locale = data.value;
                localStorage.setItem('locale', data.value);
                this.currentLang = data.value
            },
            getVersion() {
                this.axios.post("/system/version").then((response) => {
                    this.version = response.data
                }).catch((error) => {

                })
            },
            onLogout() {
                // logout();
              localStorage.removeItem("token");
              this.$router.push("/login");
            },

        },
        created() {
            this.current = window.location.hash;
            this.getVersion()
        },
        computed: {
            languageName() {
                const p = this.langs.filter(item => item.value === this.currentLang)[0].name;
                return p
            }
        }
    }
</script>

<style scoped lang="scss">
    .head {
        display: flex;
        background-color: #08245E;
        width: 100%;
        align-items: center;
        //box-shadow: 1px 1px 5px #72767b;

        .logo {
            flex-shrink: 0;
            font-family: Helvetica;
            font-size: 34px;
            font-weight: 900;
            line-height: 60px;
            text-align: center;
            color: #00EAFF;
            display: block;
            //min-width: 150px;
            //width: 200px;
            padding: 0 20px 0 20px;
            text-shadow: 2px 2px 1px rgba(0,0,0,0.4100);

            //width: auto;
        }

        .version {
            //line-height: 60px;
            padding: 30px 20px 0px 0px;
            font-size: 14px;
            color: #fff;
            //text-shadow: 2px 2px 1px #a5d4b7;
        }

        .menus {
            flex-shrink: 0;
            flex-grow: 1;
            display: flex;
            line-height: 80px;
            //font-size: 40px;
            color: #fff;

            .menu {
                margin: 0 5px;
                padding: 0 10px;
                font-size: 24px;
                font-family: PingFang SC;
                font-weight: bold;
                line-height: 82px;
                color: #FFFFFF;
                cursor: pointer;
                position: relative;

                .submenus {
                    padding: 5px 0;
                    display: none;
                    z-index: 1000;
                    position: absolute;
                    top: 60px;
                    left: 0px;
                    /*background-color: #00EAFF;*/
                    //padding: 0 10px;
                    width: 200px;

                    //font-size: 20px;
                    border-radius: 5px;
                    //border: 1px solid #00ff00;
                    .submenu {
                        font-size: 28px;
                        font-family: PingFang SC;
                        font-weight: bold;
                        line-height: 82px;
                        color: #FFFFFF;

                        padding: 0 10px;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;

                        &:hover {
                            background-color: #00EAFF;
                            color: #08245E;
                        }
                    }
                }

                /*&:hover {*/
                    /*background-color: #ffffff;*/
                    /*color: #08245E;*/

                    /*.submenus {*/
                        /*display: block;*/
                    /*}*/
                /*}*/

            }
            .menu-show{
                background-color: #ffffff;
                color: #08245E;

                .submenus {
                    display: block;
                }
            }
            .icon-group {
                width: 20px;
                height: 20px;
                background-image: url(~@/images/common/group.png);
                background-repeat: no-repeat;
                background-position: center;
                background-size: contain;
            }
        }

        .right {
            padding: 5px 10px;
            flex-shrink: 0;
            position: relative;
            border-radius: 8px;
            background-color: #0C9BAB;
            margin-right: 10px;

            .close {
                display: flex;
                align-items: center;
                cursor: pointer;

                .icon-close {
                    display: inline-block;
                    width: 20px;
                    height: 20px;
                    margin: 3px;
                    background-image: url(~@/images/common/icon_close.png);
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: contain;
                }

                .desc {
                    font-size: 14px;
                    font-family: PingFang SC;
                    font-weight: 400;
                    line-height: 32px;
                    color: #FFFFFF;
                }
            }

            .mode {
                font-family: Helvetica;
                font-weight: 900;
                font-size: 15px;
                //color: #045008;
                //text-shadow: 2px 2px 1px #a5d4b7;
                line-height: 60px;
            }

            span {
                cursor: pointer;
                line-height: 60px;
                font-size: 18px;
                color: #fff;
            }

            .options {
                position: absolute;
                right: 0;
                display: none;
                background-color: #06B176;
                color: #fff;

                line-height: 30px;

                .option {
                    cursor: pointer;
                    padding: 0 10px;

                    &:hover {
                        background-color: #059463;
                    }
                }

                &:hover {

                }
            }

            &:hover {
                .options {
                    display: block;
                }
            }
        }
    }
</style>